<template lang="pug">
#moduleContainer(v-loading="loading", element-loading-text="数据加载中...")
  .nav
    el-button(type="primary", size="small", icon="el-icon-plus", @click="addModule") 添加
    el-button(size="small", icon="el-icon-refresh", @click="getModuleList") 刷新

    el-upload(style="margin: 0 10px 0 10px", :show-file-list="false", :http-request="httpRequest",
        action="/", accept=".zip")
       el-button(size="small", icon="el-icon-upload2",) 导入
    el-button(size="small", icon="el-icon-download", @click="downFile" :disabled="!selection.length") 导出
  .content
    el-table(ref="multipleTable", highlight-current-row, size="small", border, height="100%", :data="tableData",
    @selection-change="handleSelectionChange")
      //- el-table-column(label="移动" width="50" align="center")
        i.iconfont.icon-drag.drag-option
      el-table-column(type="selection", width="50", align="center")
      el-table-column(label="序号", type="index", align="center", width="60")
      //- el-table-column(label="模块名称" align="center" prop="groupName")
      el-table-column(label="模块名称", align="center", prop="groupName")
      el-table-column(label="创建时间", align="center", prop="createTime")
      el-table-column(label="创建人", align="center", prop="createUserName")
      el-table-column(label="备注", align="center", prop="remark")
      el-table-column(label="状态", align="center", prop="tagName", v-slot="{ row }")
        span {{ row.status === 0 ? "启用" : "禁用" }}
      el-table-column(label="操作", prop="status", v-slot="{ row, $index }")
        el-button(type="text", @click="editModule(row)") 修改
        el-button.del(type="text", @click="delModule(row)") 删除
        el-button(type="text", v-if="$index !== 0", @click.stop="moveModuleUp(row)") 上移
        el-button(type="text", v-if="$index !== tableData.length - 1", @click.stop="moveModuleDown(row)") 下移
  compontent(:is="openDialog", ref="openDialog", @initTree="refresh")
  <importFileComp></importFileComp>
</template>

<script>
import importFileComp from "@/CommonDP/pages/mainMg/lowcode/tableSettings/uploaderExcel/index.vue";
import metadataService from "@/CommonDP/service/metadata-service.js";
import addModelDialog from "../dialog/addModelDialog.vue";
import editModelDialog from "../dialog/editModelDialog.vue";
export default {
  components: { importFileComp },
  data() {
    return {
      tableData: [],
      groupId: "",
      loading: false,
      openDialog: "",
      selection: []
    };
  },
  inject: ["metaSideNode"],
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.groupId = this.metaSideNode()?.data?.groupId;
      this.getModuleList();
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    async httpRequest({ file }) {
      await this.$confirm("删除现有模块中的业务模型、表单、列此操作可能会覆盖、表等相关数据及设置，请确定是否导入", "提示", {
        type: "warning"
      });
      const data = new FormData();
      data.append("file", file);
      await metadataService.importFile(data);
      this.getModuleList();
    },
    // 导出
    downFile() {
      metadataService.exportFile(this.selection.map((item) => item.groupId)).then((response) => {
        const fileName = "版本设置导出";
        if ("msSaveOrOpenBlob" in navigator) {
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.excelDisable = true;
          this.excelSelect = false;
        }
      });
    },
    async getModuleList() {
      this.loading = true;
      const res = await metadataService.getModuleList(this.groupId);
      this.tableData = res.data || [];
      this.loading = false;
    },
    refresh() {
      this.getModuleList();
      this.$emit("initTree");
    },
    // 添加模块
    async addModule() {
      this.openDialog = addModelDialog;
      await this.$nextTick();
      this.$refs.openDialog.addForm(this.metaSideNode()?.data);
    },
    // 修改模块
    async editModule(row) {
      const data = { ...row, parentId: this.groupId };
      this.openDialog = editModelDialog;
      await this.$nextTick();
      this.$refs.openDialog.openEditForm(data);
    },
    // 删除模块
    async delModule(row) {
      await this.$confirm(`删除后 ${row.groupName} 模块相关的业务模型、表单、列表、流程等都会丢失,请确认是否删除`, "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning"
      });
      try {
        await metadataService.deleteGroup(row.groupId);
        this.$success("删除成功!");
        this.refresh();
      } catch (error) {
        console.log(error);
      }
    },
    // 上移
    async moveModuleUp(row) {
      try {
        await metadataService.moveUpOrDown(row.groupId, true);
        this.$success("移动成功!");
        this.refresh();
      } catch (error) {
        console.log(error);
      }
    },
    async moveModuleDown(row) {
      try {
        await metadataService.moveUpOrDown(row.groupId, false);
        this.$success("移动成功!");
        this.refresh();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#moduleContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .nav {
    padding: 0 0 var(--middle-space);
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .content {
    overflow-y: auto;
    flex: 1 1;
  }
}
.del {
  color: #f56c6c;
}
</style>
